export const ActionsHighlightReview = {
	GET_HIGHLIGHT_REVIEW: "get_highlight_review",
	LOAD_GET_HIGHLIGHT_REVIEW: "load_get_highlight_review",
	RES_GET_HIGHLIGHT_REVIEW: "res_get_highlight_review",
	ERR_GET_HIGHLIGHT_REVIEW: "err_get_highlight_review",
	HYDRATE: "HYDRATE",
};

export function failureHighlightReview(err) {

	return {
		type: ActionsHighlightReview.ERR_GET_HIGHLIGHT_REVIEW,
		err,
	};

}

export function loadHighlightReview(params = {}) {

	return {
		type: ActionsHighlightReview.GET_HIGHLIGHT_REVIEW,
		...params,
	};

}

export function loadGetHighlightReview(params = {}) {

	return {
		type: ActionsHighlightReview.LOAD_GET_HIGHLIGHT_REVIEW,
		...params,
	};

}

export function loadHighlightReviewSuccess(data) {

	return {
		type: ActionsHighlightReview.RES_GET_HIGHLIGHT_REVIEW,
		data,
	};

}
